"use strict";
/*!
 * Copyright 2016 The ANTLR Project. All rights reserved.
 * Licensed under the BSD-3-Clause license. See LICENSE file in the project root for license information.
 */

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DFASerializer = void 0;

var ATNSimulator_1 = require("../atn/ATNSimulator");

var Decorators_1 = require("../Decorators");

var PredictionContext_1 = require("../atn/PredictionContext");

var Recognizer_1 = require("../Recognizer");

var VocabularyImpl_1 = require("../VocabularyImpl");
/** A DFA walker that knows how to dump them to serialized strings. */


var DFASerializer = /*#__PURE__*/function () {
  function DFASerializer(dfa, vocabulary, ruleNames, atn) {
    _classCallCheck(this, DFASerializer);

    if (vocabulary instanceof Recognizer_1.Recognizer) {
      ruleNames = vocabulary.ruleNames;
      atn = vocabulary.atn;
      vocabulary = vocabulary.vocabulary;
    } else if (!vocabulary) {
      vocabulary = VocabularyImpl_1.VocabularyImpl.EMPTY_VOCABULARY;
    }

    this.dfa = dfa;
    this.vocabulary = vocabulary;
    this.ruleNames = ruleNames;
    this.atn = atn;
  }

  _createClass(DFASerializer, [{
    key: "toString",
    value: function toString() {
      if (!this.dfa.s0) {
        return "";
      }

      var buf = "";

      if (this.dfa.states) {
        var states = _construct(Array, _toConsumableArray(this.dfa.states.toArray()));

        states.sort(function (o1, o2) {
          return o1.stateNumber - o2.stateNumber;
        });

        var _iterator = _createForOfIteratorHelper(states),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var s = _step.value;
            var edges = s.getEdgeMap();

            var edgeKeys = _toConsumableArray(edges.keys()).sort(function (a, b) {
              return a - b;
            });

            var contextEdges = s.getContextEdgeMap();

            var contextEdgeKeys = _toConsumableArray(contextEdges.keys()).sort(function (a, b) {
              return a - b;
            });

            var _iterator2 = _createForOfIteratorHelper(edgeKeys),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _entry = _step2.value;
                var value = edges.get(_entry);

                if ((value == null || value === ATNSimulator_1.ATNSimulator.ERROR) && !s.isContextSymbol(_entry)) {
                  continue;
                }

                var contextSymbol = false;
                buf += this.getStateString(s) + "-" + this.getEdgeLabel(_entry) + "->";

                if (s.isContextSymbol(_entry)) {
                  buf += "!";
                  contextSymbol = true;
                }

                var t = value;

                if (t && t.stateNumber !== ATNSimulator_1.ATNSimulator.ERROR.stateNumber) {
                  buf += this.getStateString(t) + "\n";
                } else if (contextSymbol) {
                  buf += "ctx\n";
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            if (s.isContextSensitive) {
              var _iterator3 = _createForOfIteratorHelper(contextEdgeKeys),
                  _step3;

              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  var entry = _step3.value;
                  buf += this.getStateString(s) + "-" + this.getContextLabel(entry) + "->" + this.getStateString(contextEdges.get(entry)) + "\n";
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      var output = buf;

      if (output.length === 0) {
        return "";
      } //return Utils.sortLinesInString(output);


      return output;
    }
  }, {
    key: "getContextLabel",
    value: function getContextLabel(i) {
      if (i === PredictionContext_1.PredictionContext.EMPTY_FULL_STATE_KEY) {
        return "ctx:EMPTY_FULL";
      } else if (i === PredictionContext_1.PredictionContext.EMPTY_LOCAL_STATE_KEY) {
        return "ctx:EMPTY_LOCAL";
      }

      if (this.atn && i > 0 && i <= this.atn.states.length) {
        var state = this.atn.states[i];
        var ruleIndex = state.ruleIndex;

        if (this.ruleNames && ruleIndex >= 0 && ruleIndex < this.ruleNames.length) {
          return "ctx:" + String(i) + "(" + this.ruleNames[ruleIndex] + ")";
        }
      }

      return "ctx:" + String(i);
    }
  }, {
    key: "getEdgeLabel",
    value: function getEdgeLabel(i) {
      return this.vocabulary.getDisplayName(i);
    }
  }, {
    key: "getStateString",
    value: function getStateString(s) {
      if (s === ATNSimulator_1.ATNSimulator.ERROR) {
        return "ERROR";
      }

      var n = s.stateNumber;
      var stateStr = "s" + n;

      if (s.isAcceptState) {
        if (s.predicates) {
          stateStr = ":s" + n + "=>" + s.predicates;
        } else {
          stateStr = ":s" + n + "=>" + s.prediction;
        }
      }

      if (s.isContextSensitive) {
        stateStr += "*";

        var _iterator4 = _createForOfIteratorHelper(s.configs),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var config = _step4.value;

            if (config.reachesIntoOuterContext) {
              stateStr += "*";
              break;
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }

      return stateStr;
    }
  }]);

  return DFASerializer;
}();

__decorate([Decorators_1.NotNull], DFASerializer.prototype, "dfa", void 0);

__decorate([Decorators_1.NotNull], DFASerializer.prototype, "vocabulary", void 0);

__decorate([Decorators_1.Override], DFASerializer.prototype, "toString", null);

exports.DFASerializer = DFASerializer;